export default __webpack_public_path__ + "b128eb3b02498d2febe472ffe214e415.svg";